import React from 'react';
import { Card, CardContent, CardHeader } from './ui/Card';
import { Users, Filter, CheckCircle, TrendingUp, BarChart3 } from 'lucide-react';
export function FunnelWidget() {
  return <Card className="w-full max-w-sm sm:max-w-md mx-auto bg-slate-900 border-slate-700 shadow-2xl overflow-hidden transition-all duration-500 sm:hover:scale-105" data-id="element-1">
      <CardHeader className="bg-slate-800 border-b border-slate-700 flex flex-row items-center justify-between p-3 sm:p-4 md:p-6 pb-3" data-id="element-2">
        <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-3">
          <div className="h-2.5 w-2.5 sm:h-3 sm:w-3 rounded-full bg-red-500" data-id="element-4" />
          <div className="h-2.5 w-2.5 sm:h-3 sm:w-3 rounded-full bg-yellow-500" data-id="element-5" />
          <div className="h-2.5 w-2.5 sm:h-3 sm:w-3 rounded-full bg-green-500" data-id="element-6" />
        </div>
        <div className="text-[10px] sm:text-xs text-slate-400 font-mono" data-id="element-7">
          widget.saas.io
        </div>
      </CardHeader>

      <CardContent className="p-4 sm:p-6 space-y-4 sm:space-y-6" data-id="element-8">
        <div className="flex items-center justify-between mb-1 sm:mb-2" data-id="element-9">
          <h3 className="text-slate-100 font-semibold flex items-center gap-1.5 sm:gap-2 text-sm sm:text-base" data-id="element-10">
            <BarChart3 className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" data-id="element-11" />
            Воронка Продаж
          </h3>
          <span className="text-[10px] sm:text-xs bg-green-500/20 text-green-400 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full" data-id="element-12">
            Active
          </span>
        </div>

        {/* Funnel Visualization */}
        <div className="space-y-1.5 sm:space-y-2" data-id="element-13">
          {/* Stage 1 */}
          <div className="relative group" data-id="element-14">
            <div className="absolute inset-0 bg-blue-500/10 rounded-lg -z-10 w-full" data-id="element-15" />
            <div className="flex items-center justify-between p-2.5 sm:p-3 rounded-lg border border-blue-500/20" data-id="element-16">
              <div className="flex items-center gap-2 sm:gap-3" data-id="element-17">
                <div className="p-1.5 sm:p-2 bg-blue-500/20 rounded-md" data-id="element-18">
                  <Users className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" data-id="element-19" />
                </div>
                <div data-id="element-20">
                  <div className="text-xs sm:text-sm font-medium text-slate-200" data-id="element-21">
                    Посетители
                  </div>
                  <div className="text-[10px] sm:text-xs text-slate-400" data-id="element-22">
                    Входной трафик
                  </div>
                </div>
              </div>
              <div className="text-right" data-id="element-23">
                <div className="text-base sm:text-lg font-bold text-white" data-id="element-24">
                  12,450
                </div>
                <div className="text-[10px] sm:text-xs text-green-400 flex items-center justify-end gap-0.5 sm:gap-1" data-id="element-25">
                  <TrendingUp className="h-2.5 w-2.5 sm:h-3 sm:w-3" data-id="element-26" /> +12%
                </div>
              </div>
            </div>
          </div>

          {/* Connector */}
          <div className="flex justify-center -my-0.5 sm:-my-1 relative z-10" data-id="element-27">
            <div className="h-3 sm:h-4 w-0.5 bg-slate-700" data-id="element-28" />
          </div>

          {/* Stage 2 */}
          <div className="relative group" data-id="element-29">
            <div className="absolute inset-0 bg-purple-500/10 rounded-lg -z-10 w-[80%] mx-auto" data-id="element-30" />
            <div className="flex items-center justify-between p-2.5 sm:p-3 rounded-lg border border-purple-500/20 w-[90%] mx-auto bg-slate-900/50" data-id="element-31">
              <div className="flex items-center gap-2 sm:gap-3" data-id="element-32">
                <div className="p-1.5 sm:p-2 bg-purple-500/20 rounded-md" data-id="element-33">
                  <Filter className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-purple-400" data-id="element-34" />
                </div>
                <div data-id="element-35">
                  <div className="text-xs sm:text-sm font-medium text-slate-200" data-id="element-36">
                    Лиды
                  </div>
                  <div className="text-[10px] sm:text-xs text-slate-400" data-id="element-37">
                    Прогрев контентом
                  </div>
                </div>
              </div>
              <div className="text-right" data-id="element-38">
                <div className="text-base sm:text-lg font-bold text-white" data-id="element-39">
                  3,840
                </div>
                <div className="text-[10px] sm:text-xs text-slate-400" data-id="element-40">
                  30.8% conv
                </div>
              </div>
            </div>
          </div>

          {/* Connector */}
          <div className="flex justify-center -my-0.5 sm:-my-1 relative z-10" data-id="element-41">
            <div className="h-3 sm:h-4 w-0.5 bg-slate-700" data-id="element-42" />
          </div>

          {/* Stage 3 */}
          <div className="relative group" data-id="element-43">
            <div className="absolute inset-0 bg-green-500/10 rounded-lg -z-10 w-[60%] mx-auto" data-id="element-44" />
            <div className="flex items-center justify-between p-2.5 sm:p-3 rounded-lg border border-green-500/20 w-[80%] mx-auto bg-slate-900/80" data-id="element-45">
              <div className="flex items-center gap-2 sm:gap-3" data-id="element-46">
                <div className="p-1.5 sm:p-2 bg-green-500/20 rounded-md" data-id="element-47">
                  <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-400" data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <div className="text-xs sm:text-sm font-medium text-slate-200" data-id="element-50">
                    Продажи
                  </div>
                  <div className="text-[10px] sm:text-xs text-slate-400" data-id="element-51">
                    Лояльные клиенты
                  </div>
                </div>
              </div>
              <div className="text-right" data-id="element-52">
                <div className="text-base sm:text-lg font-bold text-white" data-id="element-53">
                  892
                </div>
                <div className="text-[10px] sm:text-xs text-green-400" data-id="element-54">
                  23.2% conv
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-3 sm:pt-4 border-t border-slate-700" data-id="element-55">
          <div className="flex justify-between text-xs sm:text-sm" data-id="element-56">
            <span className="text-slate-400" data-id="element-57">ROI Кампании</span>
            <span className="text-green-400 font-bold" data-id="element-58">+450%</span>
          </div>
          <div className="w-full bg-slate-800 h-1.5 sm:h-2 rounded-full mt-1.5 sm:mt-2 overflow-hidden" data-id="element-59">
            <div className="bg-green-500 h-full w-[85%]" data-id="element-60" />
          </div>
        </div>
      </CardContent>
    </Card>;
}